export default __webpack_public_path__ + "static/media/132036128_897827944088302_4547396913819177905_n.08b84bed.jpg";